<!-- 文章列表 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goModal"
                    >新增文章</Button
                >
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="status">
                        <i-switch
                            v-model="row.status"
                            size="large"
                            true-color="var(--primary-color) "
                            :true-value="1"
                            :false-value="0"
                            @on-change="changeStatus(row)"
                        >
                        </i-switch>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost @click="goModal(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="600"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="文章标题:">
                        <Input
                            class="w300"
                            type="text"
                            v-model="formData.title"
                            placeholder="请输入文章标题"
                        ></Input>
                    </FormItem>
                    <FormItem label="序号:">
                        <Input
                            class="w300"
                            type="number"
                            v-model="formData.sort"
                            placeholder="请输入序号"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="var(--primary-color) "
                            />
                            <div slot="content"><p>倒序，序号越大，越在前面</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="创建时间:">
                        <DatePicker
                            class="w200"
                            :value="formData.created_at"
                            type="datetime"
                            placeholder="请选择"
                            @on-change="changeTime"
                        ></DatePicker>
                    </FormItem>
                    <FormItem label="是否发布:">
                        <i-switch
                            v-model="formData.status"
                            size="large"
                            true-color="var(--primary-color) "
                            :true-value="1"
                            :false-value="0"
                        >
                        </i-switch>
                    </FormItem>
                    <FormItem label="封面图片:">
                        <div class="form-upload" @click="openModal(1)">
                            <img
                                class="wh100"
                                v-if="show_img"
                                :src="show_img"
                            />
                            <Icon
                                v-else
                                type="ios-add"
                                size="44"
                                color="#AEAEB3"
                            />
                        </div>
                    </FormItem>
                    <FormItem label="文章内容:">
                        <editor
                            class="editor-div"
                            :edtor-con="formData.content"
                            :index="1"
                            @getContent="getEnContent"
                            @getContentchange="getEnContentchange"
                        />
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    article_list,
    article_save,
    article_status,
    article_delete,
    article_sort,
    article_info,
} from "@/api/index";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";
export default {
    components: { pictureLibrary, editor },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 30,
            },
            total: 0,
            columnsTable: [
                { type: 'index', width: 60, align: 'center' },
                { title: "排序", key: "sort", align: "center", width: "100px" },
                { title: "文章标题", key: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            formData: {
                id: "",
                title: "",
                content: "",
                sort: "",
                status: 0,
                img: "",
                created_at: "",
            },
            show_img: "",
            modals: false,
            modalTitle: "",
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_img = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.img = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList() {
            article_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 确定
        submitModal() {
            if (this.formData.created_at) {
                var data = {
                    id: this.formData.id,
                    title: this.formData.title,
                    content: this.formData.content,
                    sort: this.formData.sort,
                    status: this.formData.status,
                    img: this.formData.img,
                    created_at: this.formData.created_at,
                };
            } else {
                var data = {
                    id: this.formData.id,
                    title: this.formData.title,
                    content: this.formData.content,
                    sort: this.formData.sort,
                    status: this.formData.status,
                    img: this.formData.img,
                };
            }
            article_save(data)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        goModal(row) {
            if (row.id) {
                this.modalTitle = "编辑文章";
                this.formData.id = row.id;
                this.getInfo();
            } else {
                this.modalTitle = "新增文章";
                this.formData.id = "";
                this.formData.title = "";
                this.formData.content = "";
                this.formData.status = 0;
                this.formData.img = "";
                this.show_img = "";
                const now = new Date();
                this.formData.created_at = this.formatDateTime(now);
                this.getSort();
            }
            setTimeout(() => {
                this.modals = true;
            }, 777);
        },
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            const seconds = date.getSeconds().toString().padStart(2, "0");
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        getInfo() {
            article_info({ id: this.formData.id })
                .then((res) => {
                    this.formData.title = res.data.title;
                    this.formData.content = res.data.content;
                    this.formData.sort = res.data.sort;
                    this.formData.status = res.data.status;
                    this.formData.img = res.data.img;
                    this.formData.created_at = res.data.created_at;
                    this.show_img = res.data.show_img;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getSort() {
            article_sort()
                .then((res) => {
                    this.formData.sort = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    article_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        changeStatus(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "是否修改状态？",
                onOk: () => {
                    article_status({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.getList();
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        changeTime(e) {
            if (e) {
                this.formData.created_at = e;
            } else {
                this.formData.created_at = "";
            }
        },
        //富文本
        getEnContentchange(detailData) {
            this.formData.content = detailData.editorData;
        },
        getEnContent(detailData) {
            this.formData.content = detailData.editorData;
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.form-upload {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.wh100 {
    width: 100%;
    height: 100%;
}
.cursor-p {
    cursor: pointer;
}
.editor-div {
    width: 100%;
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>